import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { CONTACT_SUPPORT_URL } from '../../../../../config/constants';
import type { SofWizardStepFactory } from '../../types';

import issueIcon from './issueIcon.svg';
import styles from './SofIssueView.module.scss';

export const sofIssueViewFactory: SofWizardStepFactory = ({ stepsMapping }) => {
  return observer(function SofIssueView(props) {
    const { t } = useTranslation();

    return (
      <DialogContent className={styles.content}>
        <p className={styles.pseudoTitle}>{t('sof.verificationIssueTitle')}</p>
        <img alt="issue icon" className={styles.image} src={issueIcon} />
        <p className={styles.secondaryText}>{t('sof.verificationIssueDesc')}</p>
        <Button btnType="main" className={styles.tryAgainButton} onClick={() => props.forceStep(stepsMapping.init)}>
          {t('common.tryAgain')}
        </Button>
        <a className={styles.contactSupportButton} href={CONTACT_SUPPORT_URL} rel="noreferrer" target="_blank">
          {t('common.contactSupportFirstLetterUpper')}
        </a>
      </DialogContent>
    );
  });
};
